import { commentFormatter } from "./entries/comments.js";
import * as logTags from "./tags/tags.js";
import * as time from "../utils/time.js";
import { Entry } from "./entries/class-entry.js";
/**
  Read every line of the log and build the logObj out of it
  */
export function buildLogObjFromSourceLogFile(sourceLog) {
  const logObj = {
    fullLog: {},
    Years: {},
    fullLogAsc: {},
    fullLogDesc: {},
  };

  let date;
  sourceLog.forEach((line) => {
    // Skip comments
    if (line.match(window.regExes.frontMatterComment)) return;

    // Put all the dates into logObj.fullLog
    if (line.match(window.regExes.dateLogEntry)) {
      date = time.dateFormatterYYYYMMDDtoJS(line.match(window.regExes.dateLogEntry));

      logObj.fullLog[date] = { entries: [] };

      const dateNoTime = time.dateNoTime(date);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const week = time.getWeekNumber(date)[1];

      // week is depending on which month a given date falls into...
      // so i'd have to change the getWeekNumber formula to return month based on the monday of that week

      // Put dates into Year, Month and Week collections
      if (!(year in logObj.Years)) {
        logObj.Years[year] = { summary: {} };
      }

      if (!(month in logObj.Years[year])) {
        logObj.Years[year][month] = { summary: {} };
      }

      if (!(week in logObj.Years[year][month])) {
        logObj.Years[year][month][week] = { summary: {} };
      }

      if (!(dateNoTime in logObj.Years[year][month][week])) {
        logObj.Years[year][month][week][dateNoTime] = logObj.fullLog[date];
      }
    }

    // Prep the new Entry
    const times = time.timeFormatter(line.match(window.regExes.time));

    // Tags
    const tags = logTags.tagFormatter(line.match(window.regExes.tag)); // remove '#' etc.

    const mood = tags
      .filter((tag) => tag.match(/m\d/g))
      .map((x) => x.replace("m", ""))
      .join();

    const energy = tags
      .filter((tag) => tag.match(/e\d/g))
      .map((x) => x.replace("e", ""))
      .join();

    const clarity = tags
      .filter((tag) => tag.match(/c\d/g))
      .map((x) => x.replace("c", ""))
      .join();

    // todo: look at this
    const _filteredTags = tags.filter(
      (tag) => !window.fm.rhythm.some((_rhythm) => tag.match(window.regExes.rhythmTag)),
    );

    // Comments
    const comment = commentFormatter(line);

    // if the Entry has a timestamp, add it to that date's list of entries.
    if (times) {
      const entryData = {
        startTime: times[0],
        endTime: times[1],
        comment: comment,
        tags: tags,
        duration: undefined,
        rhythm: {
          mood: mood,
          energy: energy,
          clarity: clarity,
        },
      };
      logObj.fullLog[date].entries.push(new Entry(entryData));
    }
  });

  return logObj;
}
